import config from '../../../config';

const apiV1Url = config.apiUrl();
const digitalCertificatesUrl = `${apiV1Url}/BackOffice/DigitalCertificates`;

export default {
  bulkGenerate: (): string => `${digitalCertificatesUrl}/bulk-generate`,
};
